const DUPLICATE_ROW_COLOR = "#ffcdd2";
const EX_EMPLOYEE_ROW_COLOR = "#fff9c4";

export function getApplicantRowBackground(applicant) {
    if (!applicant) {
        return undefined;
    }

    if (applicant.isExEmployee) {
        return EX_EMPLOYEE_ROW_COLOR;
    }

    if (applicant.hasDuplicates) {
        return DUPLICATE_ROW_COLOR;
    }

    return undefined;
}
